"use client";

import dynamic from "next/dynamic";

const WelcomeMessage = dynamic(() => import("@/components/onboarding/WelcomeMessage"), {
  ssr: false,
});

export default WelcomeMessage;
